<template>
    <v-dialog
        v-if="confirmPhaseDialogShow"
        v-model="confirmPhaseDialogShow"
        persistent
        width="800px"
    >
        <v-form ref="confirmPhaseForm">
            <v-card>
                <v-card-title class="primary white--text"
                    >Confirm New Phase</v-card-title
                >

                <v-card-text class="pb-0">
                    <v-toolbar class="py-2" outlined flat>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-toolbar-title
                                    class="title pr-2"
                                    v-on="on"
                                >
                                    {{
                                        growthTask
                                            ? growthTask.plant.name
                                            : ""
                                    }}
                                    <div
                                        class="
                                            mt-n1
                                            grey--text
                                            text--darken-1
                                            caption
                                        "
                                        v-if="growthTask"
                                    >
                                        {{
                                            (growthTask
                                                ? growthTask.growthStartDate
                                                : "1970-01-01")
                                                | moment("YYYY-[W]WW")
                                        }}
                                    </div>
                                </v-toolbar-title>
                            </template>
                            <span>{{
                                growthTask ? growthTask.plant.name : ""
                            }}</span>
                        </v-tooltip>

                        <v-spacer />
                        <v-icon :color="taskColor" class="mr-1">eco</v-icon>
                        <span :class="taskColor + `--text headline`">{{
                            growthTask ? growthTask.totalInventory : 0
                        }}</span>
                    </v-toolbar>

                    <v-card-text>
                        <v-row class="justify-center">
                            <!-- Previous Phase -->
                            <v-col
                                cols="12"
                                md="6"
                                v-if="taskStatus !== 'PLANNED'"
                            >
                                <v-card outlined tile class="elevation-2">
                                    <v-card-title
                                        >Previous Phase</v-card-title
                                    >

                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-icon class="mr-2"
                                                    >view_quilt</v-icon
                                                >
                                                <span
                                                    >{{
                                                        currentPhase
                                                            .greenhouseDepartmentSection
                                                            .greenhouseDepartment
                                                            .name
                                                    }}-{{
                                                        currentPhase
                                                            .greenhouseDepartmentSection
                                                            .name
                                                    }}</span
                                                >
                                            </v-col>
                                            <v-col cols="12">
                                                <v-icon class="mr-2"
                                                    >spa</v-icon
                                                >
                                                <span
                                                    >{{
                                                        currentPhase.numPlantsPerM2
                                                    }}
                                                    plants/m2</span
                                                >
                                            </v-col>
                                            <v-col cols="12">
                                                <v-icon class="mr-2"
                                                    >date_range</v-icon
                                                >
                                                <span
                                                    >{{
                                                        currentPhase.startDate
                                                    }}
                                                    ~
                                                    {{
                                                        currentPhase.endDate
                                                    }}</span
                                                >
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-text class="py-0">
                                        <v-slider
                                            :value="
                                                currentPhase.phaseNo - 1
                                            "
                                            :tick-labels="
                                                generateTaskPhaseTickLabels(
                                                    growthTask
                                                        ? growthTask
                                                                .growthTaskPhaseSet
                                                                .edges
                                                        : []
                                                )
                                            "
                                            :color="taskColor"
                                            track-color="grey lighten-3"
                                            :max="
                                                growthTask
                                                    ? growthTask.numPhases
                                                    : 1
                                            "
                                            :step="1"
                                            ticks="always"
                                            tick-size="4"
                                            readonly
                                        ></v-slider>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- Next Phase -->
                            <v-col
                                cols="12"
                                md="6"
                                v-if="nextPhase !== null"
                            >
                                <v-card outlined tile class="elevation-2">
                                    <v-card-title>New Phase</v-card-title>

                                    <v-card-text>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                :class="
                                                    currentPhase
                                                        .greenhouseDepartmentSection
                                                        .id !=
                                                    nextPhase
                                                        .greenhouseDepartmentSection
                                                        .id
                                                        ? `red--text`
                                                        : ``
                                                "
                                            >
                                                <v-icon class="mr-2"
                                                    >view_quilt</v-icon
                                                >
                                                <span
                                                    v-if="
                                                        nextPhase
                                                            .greenhouseDepartmentSection
                                                            .greenhouseDepartment
                                                    "
                                                    >{{
                                                        nextPhase
                                                            .greenhouseDepartmentSection
                                                            .greenhouseDepartment
                                                            .name
                                                    }}-{{
                                                        nextPhase
                                                            .greenhouseDepartmentSection
                                                            .name
                                                    }}</span
                                                >
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                :class="
                                                    currentPhase.numPlantsPerM2 !=
                                                    nextPhase.numPlantsPerM2
                                                        ? `red--text`
                                                        : ``
                                                "
                                            >
                                                <v-icon class="mr-2"
                                                    >spa</v-icon
                                                >
                                                <span
                                                    >{{
                                                        nextPhase.numPlantsPerM2
                                                    }}
                                                    plants/m2</span
                                                >
                                            </v-col>
                                            <v-col cols="12">
                                                <v-icon class="mr-2"
                                                    >date_range</v-icon
                                                >
                                                <span
                                                    >{{
                                                        nextPhase.startDate
                                                    }}
                                                    ~
                                                    {{
                                                        nextPhase.endDate
                                                    }}</span
                                                >
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-text class="py-0">
                                        <v-slider
                                            :value="nextPhase.phaseNo - 1"
                                            :tick-labels="
                                                generateTaskPhaseTickLabels(
                                                    growthTask
                                                        ? growthTask
                                                                .growthTaskPhaseSet
                                                                .edges
                                                        : []
                                                )
                                            "
                                            :color="
                                                nextPhase.isSalesPhase
                                                    ? `orange`
                                                    : taskColor
                                            "
                                            track-color="grey lighten-3"
                                            :max="
                                                growthTask
                                                    ? growthTask.numPhases
                                                    : 1
                                            "
                                            :step="1"
                                            ticks="always"
                                            tick-size="4"
                                            readonly
                                        ></v-slider>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card-text>

                <v-card-actions class="mr-5 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="$emit('closeConfirmGrowthTaskPhaseWindow')" 
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!hasPermission('change_growthtask')"
                        outlined
                        rounded
                        color="error"
                        :loading="isSaving"
                        @click="
                            onConfirmGrowthTaskPhaseConfirmed(nextPhase.id)
                        "
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";

    export default {
        name : "ConfirmPhaseDialog",
        props : ["confirmPhaseDialogShow", "growthTask", "taskColor","currentPhase","taskStatus","nextPhase","generateTaskPhaseTickLabels","isSaving","onConfirmGrowthTaskPhaseConfirmed","","","","","","","","","","","",""],
        methods : {

        },
        created() {
            this.hasPermission = helper.hasPermission;
        },

    }
</script>